(() => {
  const body = document.querySelector('.shopify-policy__body');
  if (!body) return;
  const title = document.querySelector('.shopify-policy__title h1')?.textContent.trim().toLowerCase();
  const firstHeading = body.querySelector('h1,h2');
  if (firstHeading && (firstHeading.textContent.trim().toLowerCase() === title || (title === 'terms of service' && firstHeading.textContent.trim().toLowerCase() === 'terms & conditions'))) firstHeading.remove();
  body.querySelectorAll('p').forEach(p => {
    if (/^\d+\.\s+[^.!?]{2,65}$/.test(p.textContent.trim())) {
      const heading = document.createElement('h2');
      heading.textContent = p.textContent.trim();
      p.replaceWith(heading);
    }
  });
})();
